import { Filesystem, Directory } from "@capacitor/filesystem";
import { FileViewer } from "@capacitor/file-viewer";
import { Share } from "@capacitor/share";

export const nativeFileReadyEvent = "edubgt:native-file-ready";
export type NativeFile = { uri: string; name: string };

export function safeNativeFileName(value: string) {
  const name = value.normalize("NFC").replace(/[\\/\u0000-\u001f\u007f:*?"<>|]/g, "_").replace(/^\.+/, "").trim();
  return (name || "Dokument").slice(-160);
}

export async function downloadNativeFile(blob: Blob, fileName: string): Promise<string> {
  const name = safeNativeFileName(fileName);
  const folder = `edubgt-downloads/${crypto.randomUUID()}`;
  const path = `${folder}/${name}`;
  // Append bounded chunks instead of allocating a second full base64 copy of large ZIPs.
  const chunkSize = 768 * 1024;
  try {
    for (let offset = 0; offset < Math.max(blob.size, 1); offset += chunkSize) {
      const bytes = new Uint8Array(await blob.slice(offset, offset + chunkSize).arrayBuffer());
      let binary = "";
      for (let i = 0; i < bytes.length; i += 8192) binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
      const data = btoa(binary);
      if (offset === 0) await Filesystem.writeFile({ path, data, directory: Directory.Cache, recursive: true });
      else await Filesystem.appendFile({ path, data, directory: Directory.Cache });
    }
    const { uri } = await Filesystem.getUri({ path, directory: Directory.Cache });
    window.dispatchEvent(new CustomEvent<NativeFile>(nativeFileReadyEvent, { detail: { uri, name } }));
    return uri;
  } catch {
    await Filesystem.rmdir({ path: folder, directory: Directory.Cache, recursive: true }).catch(() => undefined);
    throw new Error("Skedari nuk u ruajt. Kontrollo hapësirën e pajisjes dhe provo përsëri.");
  }
}

export async function clearNativeDownloads() {
  await Filesystem.rmdir({ path: "edubgt-downloads", directory: Directory.Cache, recursive: true }).catch(() => undefined);
}

export async function openNativeFile(uri: string) { await FileViewer.openDocumentFromLocalPath({ path: uri }); }
export async function shareNativeFile(uri: string, fileName: string) { await Share.share({ title: fileName, files: [uri] }); }
